import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  pushProjectHistory(
    project: Boundaries["pushProjectHistory"]["request"],
  ): void;
}

function usePushProjectHistory(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isProjectHistoryPushRequestPending),
    isRequestSuccess: useSelector(selector.isProjectHistoryPushRequestSuccess),
    isRequestFailure: useSelector(selector.isProjectHistoryPushRequestFailure),
    pushProjectHistory: core.pushProjectHistory,
  };
}

export { usePushProjectHistory };
